import React from 'react';
import { Icon } from './Icon';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'terms' | 'privacy';
}
export function LegalModal({
  isOpen,
  onClose,
  type
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] overflow-y-auto" data-id="element-235" data-mp="p3oe1xdngvrk">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-236" data-mp="k6ehzyvr9lur" />

      {/* Modal */}
      <div className="relative min-h-screen flex items-start justify-center p-4 pt-20 pb-20" data-id="element-237" data-mp="3smzmb2dfzqrj">
        <div className="relative bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden" data-id="element-238" data-mp="3olecjpw7fslk">
          {/* Header */}
          <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between z-10" data-id="element-239" data-mp="1evkg7ki3004">
            <h2 className="font-serif text-2xl text-gray-900" data-id="element-240" data-mp="1hrsqd1qq8738">
              {type === 'terms' ? 'Términos de Servicio' : 'Política de Privacidad'}
            </h2>
            <button onClick={onClose} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors" data-id="element-241" data-mp="1apevircn82y1">
              <Icon name="x" size={20} className="text-gray-600" data-id="element-242" data-mp="1kpnvmg9ra8ip" />
            </button>
          </div>

          {/* Content */}
          <div className="px-8 py-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-243" data-mp="1pmxtmkb7nsi5">
            {type === 'terms' ? <TermsContent data-id="element-244" data-mp="s1s0vh3qyqok" /> : <PrivacyContent data-id="element-245" data-mp="ry466emkfy89" />}
          </div>
        </div>
      </div>
    </div>;
}
function TermsContent() {
  return <div className="prose prose-gray max-w-none" data-id="element-246" data-mp="11yelc4s5vfq2">
      <p className="text-sm text-gray-500 mb-6" data-id="element-247" data-mp="11wk0eqgw3nlz">
        Última actualización: Febrero 2025
      </p>

      <section className="mb-8" data-id="element-248" data-mp="16qehrn90vqhw">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-249" data-mp="99h13w4e38uo">
          1. Aceptación de los Términos
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-250" data-mp="e80om0ymssp5">
          Al acceder y utilizar este sitio web operado por Alexaaa Narvaez (en
          adelante, "el Sitio"), usted acepta cumplir y estar sujeto a estos
          Términos de Servicio. Si no está de acuerdo con alguna parte de estos
          términos, no debe utilizar este Sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-251" data-mp="fzicn5osa076">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-252" data-mp="ay1evj1litut">
          2. Descripción del Servicio
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-253" data-mp="3jffm1cf4f44g">
          Este Sitio es una plataforma de presentación personal que ofrece
          información sobre Alexaaa Narvaez, incluyendo contenido multimedia,
          enlaces a redes sociales y acceso a plataformas de contenido de
          terceros. El Sitio actúa como un portal informativo y promocional.
        </p>
      </section>

      <section className="mb-8" data-id="element-254" data-mp="18ljwljd8j6ay">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-255" data-mp="18krzg43zp0ik">
          3. Requisitos de Edad
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-256" data-mp="13myqx4f7ruf4">
          Este Sitio está destinado exclusivamente a personas mayores de 18
          años. Al utilizar este Sitio, usted declara y garantiza que tiene al
          menos 18 años de edad. Si es menor de 18 años, no está autorizado a
          utilizar este Sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-257" data-mp="1674ydm31e30f">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-258" data-mp="1686lioxbufyi">
          4. Propiedad Intelectual
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-259" data-mp="1ty0v8xmcnoej">
          Todo el contenido presente en este Sitio, incluyendo pero no limitado
          a:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-260" data-mp="1l3w04206nqt7">
          <li data-id="element-261" data-mp="1p6iv2bs5hrum">Fotografías e imágenes</li>
          <li data-id="element-262" data-mp="1p5hangp8vt08">Videos y contenido multimedia</li>
          <li data-id="element-263" data-mp="1p467nj3mipa6">Textos y descripciones</li>
          <li data-id="element-264" data-mp="2cv24iumxsaoa">Diseño y elementos gráficos</li>
          <li data-id="element-265" data-mp="2cu0hdrsnbxq7">Logotipos y marcas</li>
        </ul>
        <p className="text-gray-600 leading-relaxed mt-3" data-id="element-266" data-mp="2hn3ajytih55v">
          Son propiedad exclusiva de Alexaaa Narvaez o se utilizan con la debida
          autorización. Queda prohibida la reproducción, distribución,
          modificación o uso comercial de cualquier contenido sin autorización
          expresa por escrito.
        </p>
      </section>

      <section className="mb-8" data-id="element-267" data-mp="k2ez2fe5rwmq">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-268" data-mp="fz8t78uyk7gs">
          5. Enlaces a Terceros
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-269" data-mp="1cp9gt4jlchwi">
          Este Sitio puede contener enlaces a sitios web de terceros, incluyendo
          plataformas de contenido y redes sociales. Estos enlaces se
          proporcionan únicamente para su conveniencia. No tenemos control sobre
          el contenido de estos sitios y no asumimos responsabilidad por sus
          prácticas de privacidad o contenido. El acceso a estos sitios externos
          está sujeto a sus propios términos y condiciones.
        </p>
      </section>

      <section className="mb-8" data-id="element-270" data-mp="1qn7us8u02cbh">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-271" data-mp="39biqdebha3o6">
          6. Conducta del Usuario
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-272" data-mp="3eac2b2b49mm8">
          Al utilizar este Sitio, usted se compromete a:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-273" data-mp="3ib5rdz0ap7gp">
          <li data-id="element-274" data-mp="3nb1xq4wgtazf">No utilizar el Sitio para fines ilegales o no autorizados</li>
          <li data-id="element-275" data-mp="3n97dytwxjowx">No intentar acceder a áreas restringidas del Sitio</li>
          <li data-id="element-276" data-mp="3s9lhpzri0cp5">No copiar, distribuir o modificar contenido sin autorización</li>
          <li data-id="element-277" data-mp="13ah24qehdyc">
            No realizar actividades que puedan dañar o sobrecargar el Sitio
          </li>
          <li data-id="element-278" data-mp="5vv6yv66r6wl">No suplantar la identidad de otra persona o entidad</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-279" data-mp="9vcd7qtfs82t">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-280" data-mp="9vm6podowxd9">
          7. Limitación de Responsabilidad
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-281" data-mp="jul2w7h9r0jd">
          El Sitio se proporciona "tal cual" y "según disponibilidad". No
          garantizamos que el Sitio esté libre de errores o interrupciones. En
          ningún caso seremos responsables por daños directos, indirectos,
          incidentales, especiales o consecuentes que resulten del uso o la
          imposibilidad de uso del Sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-282" data-mp="2kwj71dbud3si">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-283" data-mp="2kv86dmdp0c5m">
          8. Modificaciones
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-284" data-mp="2ymebbxzqr1zw">
          Nos reservamos el derecho de modificar estos Términos de Servicio en
          cualquier momento. Las modificaciones entrarán en vigor inmediatamente
          después de su publicación en el Sitio. Su uso continuado del Sitio
          después de cualquier modificación constituye su aceptación de los
          nuevos términos.
        </p>
      </section>

      <section className="mb-8" data-id="element-285" data-mp="1ea75yobvtxgr">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-286" data-mp="19a2q90ist6rl">
          9. Ley Aplicable
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-287" data-mp="3kwd075sqr1ym">
          Estos Términos de Servicio se regirán e interpretarán de acuerdo con
          las leyes aplicables, sin tener en cuenta sus disposiciones sobre
          conflictos de leyes.
        </p>
      </section>

      <section className="mb-8" data-id="element-288" data-mp="3g5whb665io4v">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-289" data-mp="3g4uwi9zc2n9y">
          10. Contacto
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-290" data-mp="3253kufwahiz4">
          Para cualquier pregunta sobre estos Términos de Servicio, puede
          contactarnos a través de nuestras redes sociales oficiales o los
          canales de comunicación disponibles en el Sitio.
        </p>
      </section>

      <div className="mt-10 pt-6 border-t border-gray-200" data-id="element-291" data-mp="2x68wyzjgt485">
        <p className="text-sm text-gray-500 text-center" data-id="element-292" data-mp="2x8vargwy8fyt">
          © 2025 Alexaaa Narvaez. Todos los derechos reservados.
        </p>
      </div>
    </div>;
}
function PrivacyContent() {
  return <div className="prose prose-gray max-w-none" data-id="element-293" data-mp="3fbq4jz05g6ml">
      <p className="text-sm text-gray-500 mb-6" data-id="element-294" data-mp="3faeph3197cg6">
        Última actualización: Febrero 2025
      </p>

      <section className="mb-8" data-id="element-295" data-mp="3ady0k6m8cu21">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-296" data-mp="3aezcseezfmlc">
          1. Introducción
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-297" data-mp="35jk2txk3iau7">
          Alexaaa Narvaez (en adelante, "nosotros" o "nuestro") se compromete a
          proteger su privacidad. Esta Política de Privacidad explica cómo
          recopilamos, usamos y protegemos su información cuando visita nuestro
          sitio web.
        </p>
      </section>

      <section className="mb-8" data-id="element-298" data-mp="2mm95iii0xrhe">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-299" data-mp="2mnarvj4hq0ef">
          2. Información que Recopilamos
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-300" data-mp="2hqak93rzspl7">
          Podemos recopilar los siguientes tipos de información:
        </p>
        <h4 className="font-medium text-gray-800 mt-4 mb-2" data-id="element-301" data-mp="fw2uim33muv7">
          2.1 Información Automática
        </h4>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-302" data-mp="nf2fuxa4ewh7">
          <li data-id="element-303" data-mp="sf6wqoexxt7y">Dirección IP</li>
          <li data-id="element-304" data-mp="sef4nnkjydmf">Tipo de navegador y dispositivo</li>
          <li data-id="element-305" data-mp="scu67mv4aaja">Páginas visitadas y tiempo de permanencia</li>
          <li data-id="element-306" data-mp="x785i0cwh1t8">Sitio web de referencia</li>
          <li data-id="element-307" data-mp="x89jaclaw2en">Sistema operativo</li>
        </ul>
        <h4 className="font-medium text-gray-800 mt-4 mb-2" data-id="element-308" data-mp="123yjmi559nc0">
          2.2 Confirmación de Acceso
        </h4>
        <p className="text-gray-600 leading-relaxed" data-id="element-309" data-mp="4ijbsme6byri">
          Para continuar a la plataforma externa, solicitamos una confirmación
          de que el usuario es mayor de 18 años. Esta experiencia de acceso no
          solicita nombre, correo electrónico ni número de teléfono antes de la
          redirección. La plataforma de destino opera bajo sus propios términos
          y políticas de privacidad.
        </p>
        <h4 className="font-medium text-gray-800 mt-4 mb-2" data-id="element-310" data-mp="1pub3mrdnzaiy">
          2.3 Cookies y Tecnologías Similares
        </h4>
        <p className="text-gray-600 leading-relaxed" data-id="element-311" data-mp="1uvi6qd4v3lja">
          Utilizamos cookies y tecnologías similares para mejorar su
          experiencia, analizar el tráfico del sitio y personalizar el
          contenido. Puede configurar su navegador para rechazar cookies, aunque
          esto puede afectar la funcionalidad del sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-312" data-mp="1roawmr150nuz">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-313" data-mp="1rrghfu2qh3kw">
          3. Uso de la Información
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-314" data-mp="z0yequ5x9480">
          Utilizamos la información recopilada para:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-315" data-mp="13zrvqwkf3dcx">
          <li data-id="element-316" data-mp="18z4izif7amg1">Operar y mantener el sitio web</li>
          <li data-id="element-317" data-mp="18zxh5v03g3mk">Mejorar la experiencia del usuario</li>
          <li data-id="element-318" data-mp="2ff6rjx0w3z6g">Analizar el uso del sitio y las tendencias</li>
          <li data-id="element-319" data-mp="2feolk8ofe6lc">Proteger contra actividades fraudulentas o ilegales</li>
          <li data-id="element-320" data-mp="2kdi2kb2x8fq9">Cumplir con obligaciones legales</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-321" data-mp="8qobgrb5k069">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-322" data-mp="8pmobogv3n86">
          4. Servicios de Terceros
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-323" data-mp="3sd1mgkuxpo1">
          Nuestro sitio puede utilizar servicios de terceros que recopilan
          información, incluyendo:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-324" data-mp="3q6e82jdt526r">
          <li data-id="element-325" data-mp="3m5kou3bb8bk7">
            <strong data-id="element-326" data-mp="3m6457flbarw4">GoHighLevel:</strong> CRM utilizado para registrar y
            gestionar solicitudes de acceso y datos de contacto proporcionados
            voluntariamente.
          </li>
          <li data-id="element-327" data-mp="3c74uzskweo70">
            <strong data-id="element-328" data-mp="3c8pnzdrkdz2r">Meta Pixel:</strong> Para medición de navegación e
            intención de conversión, sin enviar los datos personales ingresados
            en el formulario.
          </li>
          <li data-id="element-329" data-mp="1agjlad8m8c0p">
            <strong data-id="element-330" data-mp="1af09aytzsn4q">Plataformas de Contenido:</strong> Enlaces a servicios
            externos sujetos a sus propios términos y políticas.
          </li>
        </ul>
        <p className="text-gray-600 leading-relaxed mt-3" data-id="element-331" data-mp="2zwx3cu7ufhc2">
          Estos servicios tienen sus propias políticas de privacidad que le
          recomendamos revisar.
        </p>
      </section>

      <section className="mb-8" data-id="element-332" data-mp="2pzivhizzk0vd">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-333" data-mp="2q0k99v8dz1gs">
          5. Compartir Información
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-334" data-mp="2uyvnei5pry4t">
          No vendemos ni alquilamos su información personal. Podemos compartir
          información en las siguientes circunstancias:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-335" data-mp="3nm86gico1ntd">
          <li data-id="element-336" data-mp="39m6v28yryxzn">Con proveedores de servicios que nos ayudan a operar el sitio</li>
          <li data-id="element-337" data-mp="3doajrzagfz2v">Cuando sea requerido por ley o proceso legal</li>
          <li data-id="element-338" data-mp="3dqwqjwpiuak1">
            Para proteger nuestros derechos, privacidad, seguridad o propiedad
          </li>
          <li data-id="element-339" data-mp="1yaft68rnt0ld">En conexión con una fusión, adquisición o venta de activos</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-340" data-mp="1uq5mdthewmkl">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-341" data-mp="1upcn1dks8zch">
          6. Seguridad de los Datos
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-342" data-mp="1pq9fnmhbyh1c">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger su información contra acceso no autorizado, alteración,
          divulgación o destrucción. Sin embargo, ningún método de transmisión
          por Internet es 100% seguro.
        </p>
      </section>

      <section className="mb-8" data-id="element-343" data-mp="170l319hcjnas">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-344" data-mp="171cohrh8c4nc">
          7. Sus Derechos
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-345" data-mp="1lqit5uyu6n2m">
          Dependiendo de su ubicación, puede tener los siguientes derechos:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-346" data-mp="1gwwg41orgh6a">
          <li data-id="element-347" data-mp="t7vbyqmyns6t">Acceder a la información que tenemos sobre usted</li>
          <li data-id="element-348" data-mp="oalhuxommscn">Solicitar la corrección de información inexacta</li>
          <li data-id="element-349" data-mp="o88zwkivchzl">Solicitar la eliminación de su información</li>
          <li data-id="element-350" data-mp="3npdscwmpppr7">Oponerse al procesamiento de su información</li>
          <li data-id="element-351" data-mp="3rpehpcbcnld1">Solicitar la portabilidad de sus datos</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-352" data-mp="jd714vaqtrx">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-353" data-mp="ibt8smwbt6i">
          8. Retención de Datos
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-354" data-mp="5av77qphwqbu">
          Conservamos la información recopilada durante el tiempo necesario para
          cumplir con los fines descritos en esta política, a menos que la ley
          requiera o permita un período de retención más largo.
        </p>
      </section>

      <section className="mb-8" data-id="element-355" data-mp="jb5uykvidoss">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-356" data-mp="j81o1fqnseyf">
          9. Menores de Edad
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-357" data-mp="2l1910iisukh5">
          Este sitio no está dirigido a menores de 18 años. No recopilamos
          intencionalmente información de menores. Si descubrimos que hemos
          recopilado información de un menor, tomaremos medidas para eliminarla.
        </p>
      </section>

      <section className="mb-8" data-id="element-358" data-mp="2dqcoypudkd27">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-359" data-mp="2dpb45tnk4c7a">
          10. Cambios a esta Política
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-360" data-mp="28r9lvaxyggwv">
          Podemos actualizar esta Política de Privacidad periódicamente. Le
          notificaremos cualquier cambio publicando la nueva política en esta
          página con una fecha de actualización revisada.
        </p>
      </section>

      <section className="mb-8" data-id="element-361" data-mp="2wh3wdlusxtdy">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-362" data-mp="2rhhjjdivyf5o">
          11. Contacto
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-363" data-mp="2nfwa625k8j08">
          Si tiene preguntas sobre esta Política de Privacidad o desea ejercer
          sus derechos, puede contactarnos a través de nuestras redes sociales
          oficiales o los canales de comunicación disponibles en el sitio.
        </p>
      </section>

      <div className="mt-10 pt-6 border-t border-gray-200" data-id="element-364" data-mp="1dhd1uoo5fehk">
        <p className="text-sm text-gray-500 text-center" data-id="element-365" data-mp="1dftk0tmugvdo">
          © 2025 Alexaaa Narvaez. Todos los derechos reservados.
        </p>
      </div>
    </div>;
}